<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'userList' }">Users</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ name: 'userShow', params: { id: model.id } }"
          v-if="model"
        >{{ model.email }}</el-breadcrumb-item>
        <el-breadcrumb-item>Activity</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title">User Activity Log</h2>

      <app-activity-list :user="model"></app-activity-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app-user-activity",

  props: {
    id: String
  },

  computed: {
    ...mapGetters({
      loading: "user/loading",
      model: "user/model"
    })
  },

  created() {
    this.$store
      .dispatch("user/detail", this.id)
      .catch(() => this.$router.push({ name: "userList" }));
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  }
};
</script>
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/user/user-activity.vue?3de37d99